const features_ = [
  {
    id: 1,
    title: '科幻电影周',
    desc: '精选20部高分科幻大片，从经典到新作一次看够',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20collage%20aesthetic%20with%20futuristic%20cityscapes%2C%20starships%2C%20and%20cosmic%20nebula%20background%2C%20dramatic%20blue%20and%20purple%20lighting%2C%20epic%20widescreen%20composition%2C%20professional%20movie%20promotion%20style%2C%20clean%20dark%20atmosphere%20with%20glowing%20accents%2C%20cinematic%20branding%20aesthetic&width=700&height=400&seq=carousel-01&orientation=landscape',
    tag: '进行中',
    color: 'primary',
  },
  {
    id: 2,
    title: '华语经典修复计划',
    desc: 'AI修复技术重现上世纪经典港片与内地佳作',
    img: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20retro%20aesthetic%20with%20vintage%20film%20texture%2C%20warm%20sepia%20and%20golden%20tones%2C%20old%20Hong%20Kong%20street%20scene%20cinematic%20style%2C%20nostalgic%20movie%20poster%20composition%2C%20soft%20grainy%20atmosphere%2C%20elegant%20classic%20film%20promotion%20visual&width=700&height=400&seq=carousel-02&orientation=landscape',
    tag: '热门',
    color: 'accent',
  },
  {
    id: 3,
    title: '纪录片精选辑',
    desc: '自然、历史、科技三大主题高分纪录片专题',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20style%20landscape%20with%20diverse%20ecosystems%2C%20mountains%20meeting%20ocean%20at%20golden%20hour%2C%20rich%20natural%20colors%2C%20professional%20wildlife%20cinematography%20aesthetic%2C%20epic%20widescreen%20composition%2C%20warm%20earthy%20tones%2C%20educational%20film%20promotion%20style&width=700&height=400&seq=carousel-03&orientation=landscape',
    tag: '推荐',
    color: 'secondary',
  },
  {
    id: 4,
    title: '动画电影嘉年华',
    desc: '国内外精品动画电影大集合，带娃必看清单',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20film%20aesthetic%20with%20vibrant%20storybook%20landscape%2C%20whimsical%20fantasy%20world%20with%20soft%20clouds%20and%20magical%20elements%2C%20warm%20golden%20sunlight%2C%20cheerful%20and%20playful%20atmosphere%2C%20family-friendly%20movie%20promotion%20visual%2C%20clean%20bright%20composition%2C%20gentle%20pastel%20tones&width=700&height=400&seq=carousel-04&orientation=landscape',
    tag: '即将上线',
    color: 'primary',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
            专题企划
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精选专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精心策划的影视专题合集，帮你发现更多好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features_.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <span className={`absolute top-3 left-3 px-2.5 py-0.5 text-[10px] font-medium rounded-full whitespace-nowrap ${
                  item.color === 'primary' ? 'bg-primary-500 text-white' :
                  item.color === 'accent' ? 'bg-accent-500 text-white' :
                  'bg-secondary-500 text-white'
                }`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}